import { render, staticRenderFns } from "./adf-settings-dialog.vue?vue&type=template&id=b2d08c04&scoped=true&"
import script from "./adf-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./adf-settings-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d08c04",
  null
  
)

export default component.exports